import React from "react";

import ProductsPage from "../routes/products-page";

const ProductsTemplate = (props) => <ProductsPage {...props} />;

export default ProductsTemplate;
